<template>
  <div>
    <Loader v-if="loading" />
    <b-row v-else>
      <b-col cols="12" md="4">
        <div class="card mb-3 p-3">
          <BaseText :maxlength="2000" :value="model.price" @input="model.price = $event" title="قیمت" placeholder="قیمت (تومان) " />

          <BaseText
            v-if="['mooc-edit-packages', 'mooc-add-packages'].includes($route.name)"
            :maxlength="2000"
            :value="model.discount"
            @input="model.discount = $event"
            title="قیمت با تخفیف"
            placeholder="قیمت با تخفیف (تومان) "
            class="mt-2"
          />

          <BaseText v-else :maxlength="2000" :value="model.dicount" @input="model.dicount = $event" title="قیمت با تخفیف" placeholder="قیمت با تخفیف (تومان) " class="mt-2" />
        </div>

        <div class="card mb-3 p-3">
          <ComboBox
            v-if="!$route.path.includes('faculty')"
            :searchedData="courseFacultis"
            title="دانشکده"
            placeholder="دانشکده"
            :selectedValue="selectedFaculti"
            :showError="submit && !$route.path.includes('faculty') && !model.facultyId"
            :errortext="errorText"
            @select="fillSelectedFaculti"
            :inputStyle="comboStyle"
            :required="$route.fullPath.includes('facultyuniversitycourses') ? false : true"
          />
          <BaseText v-else disable :maxlength="2000" :value="model.facultyTitle" @input="model.facultyTitle = $event" title="دانشکده" placeholder="دانشکده" />
        </div>
        <div class="card mb-3 p-3">
          <BaseText disable :maxlength="2000" :value="model.code" @input="model.code = $event" title="کد مجوز" placeholder="کد مجوز" />
          <div class="mt-2">
            <CountInput :value="model.capacity" @input="model.capacity = $event" title="تعداد ثبت نام" placeholder="تعداد ثبت نام" />
          </div>
        </div>
        <div class="card mb-3 p-3">
          <div class="section-title">وضعیت دوره <span style="color: rgb(254, 94, 97)">*</span></div>
          <Radio :componentData="cuorseTypes" :value="model.packageType" @input="model.packageType = $event" />
          <label v-if="submit && ![0, 1].includes(model.packageType)" :class="{ course_type_error: submit && ![0, 1].includes(model.packageType) }">{{ errorText }}</label>
        </div>
        <div class="card mb-3 p-3">
          <div class="section-title">موضوع <span style="color: rgb(254, 94, 97)">*</span></div>
          <div class="mt-3">
            <BaseText :maxlength="2000" :value="search" @input="search = $event" placeholder="جستجو" />
          </div>
          <div :class="{ subject: filteredCategory.length > 5 }">
            <Radio :componentData="filteredCategory" :value="model.packageCategoryId" @input="model.packageCategoryId = $event" />
          </div>

          <label v-if="submit && !model.packageCategoryId" :class="{ course_type_error: submit && !model.packageCategoryId }">{{ errorText }}</label>
        </div>
        <div class="card p-3 mt-3 my-auto d-flex flex-column justify-content-between">
          <div class="d-flex justify-content-between">
            <b-form-checkbox v-model="model.isEnable" class="pt-2">
              <div class="mx-1">فعال بودن دوره</div>
            </b-form-checkbox>
            <b-button @click="$bvModal.show('deleteModal')" variant="outline-secondary">
              <i class="far fa-times-circle"></i>
              <span class="ms-2">حذف دوره</span>
            </b-button>
          </div>
        </div>
        <div class="inner__style mt-3">
          <div v-if="images.length === 0" class="upload-photo-icon d-flex mx-auto justify-content-center align-items-center" @click="$bvModal.show('cropperModal')">
            <div>
              <i class="fas fa-cloud-upload-alt icon-size"></i>
              <div class="upload-text-size">عکس دوره را انتخاب کنید</div>
            </div>
          </div>
          <div v-else class="grand-parent">
            <div class="uploaded-photo-main">
              <div v-for="(image, index) in images" :key="index" class="uploaded-photo">
                <div class="remove-icon" @click="removeImage({ index, image })">
                  <i class="fa fa-times"></i>
                </div>
                <img class="previewImage" @click="changeSelectedImage(image)" :src="image" :class="{ selected: model.selectedImage == image }" />
              </div>
              <div v-if="images.length < 2" @click="$bvModal.show('cropperModal')" class="uploaded-photo addNewImageIconContainer">
                <i class="fa fa-plus"></i>
              </div>
            </div>
          </div>
        </div>
        <div v-if="model.licenseStatus && model.licenseStatus > 0 && $route.path.includes('faculty')" class="card mt-3 p-3">
          <div class="d-flex justify-content-between">
            <strong>وضعیت درخواست</strong>
            <div v-if="model.licenseStatus === 4" class="accept-badge">تایید شده</div>
            <div v-if="model.licenseStatus === 3" class="reject-badge">رد شده</div>
            <div v-if="model.licenseStatus === 2" class="need-badge">نیاز به اصلاح</div>
            <div v-if="model.licenseStatus === 1" class="waiting-badge">در حال بررسی</div>
          </div>
          <template v-if="model.licenseStatus === 3 || model.licenseStatus === 2">
            <div class="mt-3">علت رد درخواست:</div>
            <div class="mt-2">{{ model.licenseDescription }}</div>
          </template>
        </div>
      </b-col>
      <b-col cols="12" md="8">
        <div class="card">
          <Section title="اطلاعات دوره">
            <div class="my-3">
              <BaseText :maxlength="2000" :value="model.title" @input="model.title = $event" title="عنوان فارسی دوره" placeholder="عنوان فارسی دوره" secondTitle="عنوان چاپ مدرک" />
            </div>
            <div class="my-3">
              <BaseText
                :maxlength="2000"
                :value="model.englishTitle"
                @input="model.englishTitle = $event"
                title="عنوان انگلیسی دوره"
                placeholder="عنوان انگلیسی دوره"
                secondTitle="عنوان چاپ مدرک"
              />
            </div>
            <div class="my-3">
              <BaseText :maxlength="2000" :value="model.shortDescription" @input="model.shortDescription = $event" title="تعریف دوره" placeholder="تعریف دوره" />
            </div>
            <div class="my-3">
              <EditorInput :value="model.fullDescription" @input="model.fullDescription = $event" title="ضرورت ارائه دوره و مخاطبین دوره" textAreaClass="align-items-center" />
            </div>
          </Section>
        </div>
        <div class="card">
          <div class="date-header">اطلاعات دوره</div>
          <Section title="وضعیت دوره">
            <div class="my-3">
              <BaseText
                inputType="number"
                :maxlength="2000"
                :value="+model.onlinePercentage"
                @input="model.onlinePercentage = $event"
                title="درصد آنلاین"
                placeholder="درصد آنلاین"
              />
            </div>
            <div class="my-3">
              <BaseText
                inputType="number"
                :maxlength="2000"
                :value="+model.offlinePercentage"
                @input="model.offlinePercentage = $event"
                title="درصد آفلاین"
                placeholder="درصد آفلاین"
              />
            </div>
            <div class="my-3">
              <BaseText
                inputType="number"
                :maxlength="2000"
                :value="+model.inclassPercentage"
                @input="model.inclassPercentage = $event"
                title="درصد حضوری"
                placeholder="درصد حضوری"
              />
            </div>
          </Section>
          <Section title="تعداد جلسات">
            <div>
              <BaseText :maxlength="2000" :value="model.numberOfSessions" @input="model.numberOfSessions = $event" title="تعداد جلسات" placeholder="تعداد جلسات" />
            </div>
          </Section>
          <Section title="مدت دوره">
            <div>
              <BaseText :maxlength="2000" :value="model.duration" @input="model.duration = $event" title="مدت دوره" placeholder="مدت دوره" />
            </div>
          </Section>
          <Section v-if="!model.packageType || model.packageType === 0 || model.packageType === 1" title="تاریخ دوره">
            <div>
              <DateTimeOffset range :value="dateRange" @input="dateRange = $event" title="تاریخ دوره" placeholder="تاریخ دوره" :hasDefaultDate="false" :key="dateRender" />
            </div>
          </Section>
          <Section v-if="(!model.packageType || model.packageType === 2) && model.packageType !== 0" title="تاریخ انتشار">
            <div>
              <DateTimeOffset
                :value="model.releaseDate"
                @input="model.releaseDate = $event"
                title="تاریخ انتشار"
                placeholder="تاریخ انتشار"
                :hasDefaultDate="false"
                :key="dateRender"
              />
            </div>
          </Section>
          <Section title="توضیحات تکمیلی">
            <div>
              <EditorInput :value="model.extraDescription" @input="model.extraDescription = $event" title="توضیحات تکمیلی" :hasImage="false" textAreaClass="align-items-center" />
            </div>
          </Section>
        </div>

        <!-- <div class="card">
          <Section title="تنظیمات سئو">
            <div class="my-3">
              <Tags title="کلیدواژه" :value="model.seoKeyword" classes="tags" @input="model.seoKeyword = $event" placeholder="کلیدواژه" />
            </div>
            <div class="my-3">
              <TextAreaInput :value="model.seoDescription" @input="model.seoDescription = $event" title="توضیحات" textAreaClass="align-items-center" />
            </div>
            <div class="my-3">
              <BaseText :maxlength="2000" :value="model.seoUrlDescription" @input="model.seoUrlDescription = $event" title="متن URL" placeholder="متن URL" />
            </div>
          </Section>
        </div> -->
      </b-col>
    </b-row>
    <div class="card p-3 d-flex flex-row justify-content-end">
      <b-button variant="outline-secondary" @click="$router.push($route.path.includes('faculty') ? '/list/facultyuniversitycourses' : '/list/universitycourses')">انصراف</b-button>
      <b-button variant="primary ms-2 px-5" @click="addPackage">ثبت پیش نویس</b-button>
    </div>
    <b-modal id="deleteModal" no-close-on-esc hide-footer centered headerClass="p-3 border-bottom-0" header-close-variant="dark" cancel-title>
      <div class="error-wrapper">
        <div class="mb-4 text-center">
          <img src="@/assets/images/checked1.svg" />
        </div>
        <div class="error-title text-center">آیا از حذف دوره اطمینان دارید؟</div>
        <div class="mt-3 float-right w-100">
          <div class="d-flex align-items-center justify-content-center">
            <b-button class="col-6" variant="secondary" block @click="$bvModal.hide('deleteModal')">خیر</b-button>
            <b-button class="ms-2 col-6" variant="primary" block @click="deletePackage">بله</b-button>
          </div>
        </div>
      </div>
    </b-modal>
    <Toast :title="message" :error="error" :showToast="message !== ''" />
    <b-modal id="cropperModal" no-close-on-esc hide-footer centered size="md" header-close-variant="dark" cancel-title>
      <template #modal-title>کراپ عکس</template>
      <div class="p-3">
        <ImageCropper :cropperLoading="cropperLoading" @imageSourceChanged="uploadImage($event)" :cropSize="imageCrop" cropShape="rectangle-stencil"> </ImageCropper>
      </div>
    </b-modal>
  </div>
</template>
<script>
import BaseText from '../../common/form/formModules/BaseText.vue'
import fileMannager from '../../../services/file'
import moocPackagesProvider from '../../../services/mooc/package'
import Toast from '../../common/Toast.vue'
import Loader from '../../widgets/loader.vue'
import ImageCropper from '../../user/ImageCropper.vue'
import Section from '../../common/form/Section.vue'
import Radio from '../../common/form/formModules/Radio.vue'
import DateTimeOffset from '../../common/form/formModules/DateTimeOffset.vue'
import ComboBox from '../../common/form/formModules/ComboBox.vue'
import EditorInput from '../../common/form/formModules/editorInput.vue'
import CountInput from '../../common/form/CountInput.vue'

let controller = new AbortController()
export default {
  name: 'AddPackage',
  components: { Toast, Loader, ImageCropper, Section, BaseText, Radio, DateTimeOffset, ComboBox, EditorInput, CountInput },
  props: {
    create: {
      type: Boolean,
      default: false,
    },
    update: {
      type: Boolean,
      default: false,
    },
    data: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      model: {
        facultyId: '',
        title: '',
        englishTitle: '',
        shortDescription: '',
        fullDescription: '',
        extraDescription: '',
        startDate: '',
        onlinePercentage: 0,
        offlinePercentage: 0,
        inclassPercentage: 0,
        endDate: '',
        deadlineDate: '',
        numberOfSessions: '',
        capacity: '',
        releaseDate: '',
        packageId: '',
        image: '',
        imageAlternateText: '',
        selectedImage: '',
        selectedImageAlternateText: '',
        courseScore: '',
        isEnable: true,
        packageType: '',
        price: '',
        dicount: '',
        discount: '',
        isFree: false,
        hour: '',
        numberOfSells: '',
        duration: '',
        holdingType: '',
        packageCategoryId: '',
      },
      errorText: 'وارد کردن این فیلد الزامی است.',
      search: '',
      comboStyle: 'color: #495057',
      selectedTeachers: [],
      selectedFaculti: '',
      numberOfAddedCourse: null,
      cuorseTypes: [
        {
          value: 'الکترونیکی',
          key: 1,
        },
        {
          value: 'حضوری',
          key: 0,
        },
      ],
      packageCategories: [],
      courseTeachers: [],
      courseFacultis: [],
      dateRange: [],
      images: [],
      message: '',
      cropperLoading: false,
      submit: false,
      error: false,
      loading: false,
      pageHeaderItems: [
        { text: 'داشبورد', href: '/' },
        { text: 'مدیریت دوره', active: true },
      ],
      imageCrop: { width: 400, height: 200 },
      updateForm: false,
      dateRender: true,
      percentCompleted: 0,
    }
  },
  watch: {
    'model.deadlineDate'(c) {
      if (c && !c.includes('T')) {
        this.model.deadlineDate = this.model.deadlineDate.replaceAll('/', '-') + 'T00:00:00.000Z'
      }
    },
    'model.releaseDate'(c) {
      if (c && !c.includes('T')) {
        this.model.releaseDate = this.model.releaseDate.replaceAll('/', '-') + 'T00:00:00.000Z'
      }
    },
    'model.price'(c) {
      if (c && !this.submit) {
        this.model.price = c.replace(/\D/g, '').replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      }
    },
    'model.dicount'(c) {
      if (c && !this.submit) {
        this.model.dicount = c.replace(/\D/g, '').replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      }
    },
    'model.discount'(c) {
      if (c && !this.submit) {
        this.model.discount = c.replace(/\D/g, '').replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      }
    },
    'images.length'(c) {
      const selected = this.images[0]
      if (c <= 1) {
        if (!this.model.selectedImage && this.images.length) {
          this.model.selectedImage = selected
        }
      }
    },
    dateRange(c) {
      if (c.length > 1) {
        const start = c[0]
        const end = c[1]
        this.model.startDate = start.replaceAll('/', '-') + 'T00:00:00.000Z'
        this.model.endDate = end.replaceAll('/', '-') + 'T00:00:00.000Z'
      }

      if (c.length === 1) {
        this.model.startDate = c[0].replaceAll('/', '-') + 'T00:00:00.000Z'
      }
      if (!c) {
        this.model.startDate = null
        this.model.endDate = null
      }
    },
  },
  computed: {
    filteredCategory() {
      return this.packageCategories.filter((item) => {
        return item.value.includes(this.search)
      })
    },
  },
  async mounted() {
    await this.fetchPackageInputs()
    if (this.update) {
      this.fetchPackage(+this.$route.params.packageId)
    }
    if (this.model.facultyId) this.fillSelectedFaculti()
    this.loading = false
    setTimeout(() => {
      window.scrollTo(0, 0)
    }, 10)
    setTimeout(() => {
      this.dateRender = false
    }, 3000)
  },
  methods: {
    fillSelectedFaculti(e) {
      if (!e) {
        this.model.facultyId = null
        return false
      }
      this.model.facultyId = this.courseFacultis.find((item) => item.value === e).key
    },
    checkRoute(id) {
      const mainRoute = this.$route.path.split('/')[2]
      setTimeout(() => {
        this.$router.push(`/list/${mainRoute}/detail/${id}`)
      }, 2000)
    },
    async addPackage() {
      this.submit = true
      if (
        (['longuniversitypackages', 'shortuniversitypackages'].includes(this.$route.path) && !this.model.facultyId) ||
        !this.model.packageCategoryId ||
        ![0, 1].includes(this.model.packageType)
      ) {
        return false
      }
      this.loading = true
      this.model.image = this.images.find((item) => item !== this.model.selectedImage)
      this.model.isFree = false
      if (!this.model.price && !this.model.dicount) {
        this.model.isFree = true
      }
      if (!this.model.price && !this.model.discount) {
        this.model.isFree = true
      }
      if (+this.model.price === 0 && +this.model.dicount === 0) {
        this.model.isFree = true
      }
      if (+this.model.price === 0 && +this.model.discount === 0) {
        this.model.isFree = true
      }
      if (this.dateRange.length === 1) {
        this.model.endDate = this.model.startDate
      }
      try {
        if (this.update) {
          await this.checkData()
          const req = await moocPackagesProvider.updatePackage({
            ...this.model,
            PackageHourType: ['facultyshortuniversitypackages', 'shortuniversitypackages'].includes(this.$route.path) ? 0 : 1,
          })
          if (req.status === 200) {
            this.$emit('update', !this.updateForm)
            this.loading = false
          } else {
            this.error = true
            this.message = 'خطایی رخ داده لطفا دوباره تلاش کنید.'
          }
          return false
        }
        if (!this.model.price && !this.model.dicount) {
          this.model.isFree = true
          this.model.price = 0
          this.model.dicount = 0
        }
        if (!this.model.price && !this.model.discount) {
          this.model.isFree = true
          this.model.price = 0
          this.model.discount = 0
        }
        await this.checkData()

        const req = await moocPackagesProvider.addPackage({
          ...this.model,
          PackageHourType: this.$route.path.includes('facultyshortuniversitypackages') || this.$route.path.includes('shortuniversitypackages') ? 0 : 1,
        })
        if (req.status === 200) {
          this.message = 'دوره جامع با موفقیت ثبت شد.'

          this.checkRoute(req.data.data)
          // setTimeout(() => {
          //   console.log(this.$route)
          //   this.$router.push(
          //     ((this.$route.path.includes('shortuniversitypackages') ? '/list/shortuniversitypackages/detail/' : this.$route.path.includes('longuniversitypackages'))
          //       ? '/list/longuniversitypackages/detail/'
          //       : this.$route.path.includes('facultylonguniversitypackages')
          //       ? '/list/facultylonguniversitypackages/detail/'
          //       : '/list/facultyshortuniversitypackages/detail/') + req.data.data,
          //   )
          // }, 2000)
        } else {
          this.error = true
          this.loading = false
          this.message = 'خطایی رخ داده لطفا دوباره تلاش کنید.'
        }
      } catch (error) {
        this.loading = false
      }
    },
    async fetchPackage() {
      this.loading = true
      try {
        if (this.update) {
          const req2 = await moocPackagesProvider.getPackage(+this.$route.params.packageId)
          this.model = req2.data.data.output
          this.numberOfAddedCourse = req2.data.data.output.numberOfAddedCourse

          this.$emit('numberOfAddedCourse', this.numberOfAddedCourse)
          if (this.model.selectedImage) {
            this.images.push(this.model.selectedImage)
          }
          if (this.model.image) {
            this.images.push(this.model.image)
          }
          this.model.price = this.model.price.toString()
          this.model.dicount = this.model.dicount.toString()
          this.model.discount = this.model.discount.toString()

          if (this.model.startDate) {
            this.dateRange[0] = this.model.startDate.slice(0, 10).replaceAll('-', '/')
          }
          if (this.model.endDate) {
            this.dateRange[1] = this.model.endDate.slice(0, 10).replaceAll('-', '/')
          }
          // this.dateRange = [this.model.startDate.slice(0, 10).replaceAll('-', '/') || '', this.model.endDate.slice(0, 10).replaceAll('-', '/') || '']

          this.courseFacultis.filter((item) => {
            if (item.key === this.model.facultyId) {
              this.selectedFaculti = item.value
            }
          })
          delete this.model.teachers
        }

        this.loading = false
      } catch (error) {
        console.log(error)
        this.loading = false
      }
    },
    async fetchPackageInputs() {
      this.loading = true
      const req = await moocPackagesProvider.getInputs()
      req.data.data.output.categories.forEach((item) => {
        this.packageCategories.push({ value: item.title, key: item.id })
      })

      req.data.data.output.faculties.forEach((item) => {
        this.courseFacultis.push({ value: item.title, key: item.id })
      })
      this.model.facultyTitle = req.data.data.output.title
    },
    async uploadImage(e) {
      this.cropperLoading = true
      const req = await fileMannager.addImage({
        base64image: e,
      })
      this.images.push(req.data.data.downloadUrl)
      this.cropperLoading = false
      this.$bvModal.hide('cropperModal')
    },
    removeImage(payload) {
      this.images.splice(payload.index, 1)
      if (payload.image === this.model.image) {
        this.model.image = ''
      }
      if (payload.image === this.model.selectedImage) {
        this.model.selectedImage = ''
      }
      this.changeSelectedImage(payload.image)
    },

    preload(e, item) {
      this.model[item] = e
    },
    async deletePackage() {
      this.loading = true
      try {
        const req = await moocPackagesProvider.deletePackage(+this.$route.params.packageId)
        this.$bvModal.hide('deleteModal')
        if (req.status === 200) {
          if (this.$route.path.includes('facultyshortuniversitypackages')) {
            this.$router.push((!this.$route.path.includes('faculty') ? '/list/shortuniversitypackages' : '/list/facultyshortuniversitypackages') + localStorage.getItem('query'))
          } else if (this.$route.path.includes('facultylonguniversitypackages')) {
            this.$router.push((!this.$route.path.includes('faculty') ? '/list/longuniversitypackages' : '/list/facultylonguniversitypackages') + localStorage.getItem('query'))
          }
        } else {
          this.error = true
          this.loading = false
          this.message = 'خطایی رخ داده لطفا دوباره تلاش کنید.'
        }
      } catch (error) {
        this.loading = false
      }
    },
    addFaculti(e) {
      this.model.facultyId = e.key
    },
    checkData() {
      this.submit = true
      for (const key in this.model) {
        if (this.model[key] === '' || this.model[key] === undefined || this.model[key] === null) {
          delete this.model[key]
        }
      }
      if (this.model.packageType === '' || this.model.packageType === undefined) {
        return false
      }
      if (this.model.price && typeof this.model.price === 'string') {
        this.model.price = this.model.price.replace(/[^a-zA-Z0-9 ]/g, '')
        this.model.price = +this.model.price
      }
      if (this.model.dicount && typeof this.model.dicount === 'string') {
        this.model.dicount = this.model.dicount.replace(/[^a-zA-Z0-9 ]/g, '')
        this.model.dicount = +this.model.dicount
      }
      if (this.model.discount && typeof this.model.discount === 'string') {
        this.model.discount = this.model.discount.replace(/[^a-zA-Z0-9 ]/g, '')
        this.model.discount = +this.model.discount
      }
    },
    changeSelectedImage(image) {
      if (this.model.selectedImage !== image) {
        this.model.selectedImage = image
        const imageDescription = this.model.selectedImageDescription
        const imageAlternateText = this.model.selectedImageAlternateText
        this.model.selectedImageAlternateText = this.model.imageAlternateText
        this.model.selectedImageDescription = this.model.imageDescription
        this.model.imageDescription = imageDescription
        this.model.imageAlternateText = imageAlternateText
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.image {
  border-radius: 100%;
  width: 200px;
  height: 200px;
  margin: auto;
}

.tags {
  ::v-deep .badge-secondary {
    background: #dde3ff !important;
    font-size: 14px !important;
    color: #556be6 !important;
    margin: 2px;
    button {
      color: #556be6;
      background: #dde3ff;
    }
  }
}

.inner__style {
  background-color: white;
  padding: 23px;
}

.uploaded-photo-main {
  display: flex;
  flex-wrap: wrap;
}
.uploaded-photo {
  height: 120px;
  width: 160px;
  position: relative;
  margin-left: 10px;
  margin-bottom: 10px;
  img {
    width: 100%;
    height: 100%;
  }
}
.uploaded-video {
  position: relative;
  img {
    width: 100%;
    height: 100%;
  }
}
.remove-icon {
  position: absolute;
  top: 5px;
  left: 5px;
  background-color: gray;
  border-radius: 50%;
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  z-index: 1;
  justify-content: center;
  cursor: pointer;
  i {
    color: white;
  }
}
.upload-text-size {
  font-size: 18px;
  text-align: center;
  margin-top: 10px;
  color: #495057;
}
.icon-size {
  font-size: 45px;
  text-align: center;
  display: block;
  color: #74788d;
}

.upload-photo-icon {
  height: 250px;
  width: 100%;
  border: 2px dashed #ced4da;
  border-radius: 8px;
  cursor: pointer;
}
.grand-parent {
  padding: 20px;
  border: 2px dashed #ced4da;
  justify-content: right;
  display: flex;
  align-items: right;
  position: relative;
}
.activeImageClass {
  border: 3px solid #556ee6;
  border-radius: 5px;
}
.remove-field-link {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  cursor: pointer;
  i {
    color: #ff4861;
  }
}
.previewImage {
  border-radius: 4px;
}
.previewVideo {
  border-radius: 4px;
  width: 100%;
}

.checkbox-margin {
  margin-right: 8px;
}

.section-title {
  font-size: 16px;
}
::v-deep .custom-control-label {
  margin-right: 10px !important;
}

::v-deep .custom-control-input {
  border: 1px solid #556ee6 !important;
}

::v-deep .text-muted {
  display: none;
}

.date-header {
  font-size: 17px;
  margin: 16px;
}

.selected {
  border: 3px solid #556be6;
}

.upload-video-parent {
  width: 100%;
}

::v-deep .b-form-tags-button {
  display: none;
}
.accept-badge {
  width: 95px;
  height: 22px;
  font-size: 13px;
  color: #34c38f;
  text-align: center;
  background: rgba(52, 195, 143, 0.1);
  // border: 1px solid rgba(52, 195, 143, 0.3);
  border-radius: 100px;
}

.reject-badge {
  width: 95px;
  height: 22px;
  color: #f46a6a;
  font-size: 13px;
  text-align: center;
  background: rgba(244, 106, 106, 0.180392);
  // border: 1px solid rgba(255, 35, 87, 0.3);
  border-radius: 100px;
}

.need-badge {
  width: 95px;
  height: 22px;
  font-size: 13px;
  color: #556ee6;
  text-align: center;
  background: rgba(85, 110, 230, 0.1);
  // border: 1px solid rgba(85, 110, 230, 0.3);
  border-radius: 100px;
}

.waiting-badge {
  width: 95px;
  height: 22px;
  color: #fcbd35;
  font-size: 13px;
  text-align: center;
  background: rgba(240, 209, 34, 0.18);
  // border: 1px solid rgba(255, 35, 87, 0.3);
  border-radius: 100px;
}

::v-deep .card {
  overflow: visible;
}

.subject {
  max-height: 150px;
  min-height: 150px;
  overflow-y: auto;
}

.course_type_error {
  color: rgb(254, 94, 97);
}

::v-deep .input__style {
  font-weight: 600;
}

::v-deep .disableInput {
  color: black !important;
  font-weight: 600;
}
</style>
